import { pushRepeats } from '../constants';

export const getPushRepeatRu = (interval?: number | null) => {
  const response = pushRepeats.find(el => el.id === interval);
  if (!response) return '-';
  return response.name;
};
